// extracted by mini-css-extract-plugin
export default {"tooltip":"In-z","sharingV2":"Jn-z","sharingIconsV2":"Kn-z","links":"Ln-z","link":"Mn-z","facebookV2":"Nn-z","twitterV2":"On-z","pinterestV2":"Pn-z"};